<template>
    <auth-layout id="password-forget-page" class="h-100">
        <div class="col-12 col-md-6 col-lg-4">
            <div class="row py-4">
                <div class="col-12">
                    <h2>{{ $t('meta.auth.forgetPassword.title') }}</h2>
                </div>
            </div>

            <section id="login-form">
                <div class="row">
                    <div class="col-12 pb-5">
                        <b-form-group
                            :label="$t('cdb.profile.form.email.label')"
                            label-for="email"
                        >
                            <b-form-input id="email"
                                     :placeholder="$t('cdb.profile.form.email.filler')"
                                     type="email"
                                     v-model="email"
                                     v-on:keyup.native.enter="handleForgotPassword"
                            ></b-form-input>
                        </b-form-group>
                    </div>

                    <div class="col-12 d-flex justify-content-end p-0">
                        <div class="col-12 col-xl-8 d-flex justify-content-end">
                            <b-button variant="primary" @click="handleForgotPassword" block>
                                {{ $t('meta.auth.passwordReset.title') }}
                            </b-button>
                        </div>
                    </div>
                    <div class="col-12 pt-3">
                        <div v-if="showSuccess" class="text-primary">{{ $t('pwfg.note')}}</div>
                        <div v-if="showError" class="text-danger">{{ $t('pwfg.error')}}</div>
                    </div>
                </div>
            </section>
        </div>
    </auth-layout>
</template>

<script>
import AuthLayout from "../../layouts/AuthLayout.vue";
import { BFormGroup, BFormInput, BButton } from "bootstrap-vue";
export default {
    components: {
        AuthLayout,
        BFormGroup, BFormInput, BButton
    },
    data() {
        return {
            email: '',
            showSuccess: false,
            showError: false
        }
    },
    methods: {
        handleForgotPassword() {
            this.showSuccess = false;
            this.showError = false;
            if(this.email.length === 0 || this.showSuccess) {
                return;
            }

            this.$axios.post('api/forgot-password', {
                email: this.email,
            })
                .then(() => {
                    this.showSuccessInfo()
                })
                .catch(() => {
                    this.showError = true
                });
        },

        showSuccessInfo() {
            this.showSuccess = true;
        }
    },
    head: {
        title: function () {
            return {
                inner: this.$root.whitelabel.state.settings.meta_title,
                complement: this.$t('meta.auth.forgetPassword.title')
            }
        },
        meta: function () {
            return [
                { name: 'description', content: this.$t('meta.auth.forgetPassword.description') }
            ]
        }
    }
}
</script>
